import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';
import { getShortVideoShareComments } from '../../../../../services/api';
import Comment from './Comment';
import { callApp, getSchemeLink } from '@ifeng-fe/callapp';
import { WxLaunchApp } from 'ThreeTerminal_mobile_dynamic';

const Comments = ({ content }) => {
    const { commentUrl, closeDrag, pid, isVideoShare } = content;

    const [initDone, setInitDone] = useState(false);
    const [comments, setComments] = useState([]);

    useEffect(() => {
        getShortVideoShareComments({ doc_url: commentUrl, p: 1 })
            .then(res => {
                if (res && res.comments && Array.isArray(res.comments) && res.comments.length > 0) {
                    setComments(res.comments);
                }
            })
            .catch(e => {
                console.error(e);
            })
            .finally(() => {
                setInitDone(true);
            });
    }, []);

    const handleMoreClick = (isSendCount = true, isJumpQQlink = false, isCallApp = true) => {
        const downloads = isVideoShare
            ? {}
            : {
                  download: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1526408179031',
                  downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=8983',
              };
        const client = isVideoShare ? 'videoApp' : 'newsApp';

        if (isCallApp) {
            callApp({
                client,
                docType: 'phvideo',
                pid,
                kind: 'inter_fxy19',
                download: downloads.download,
                downloadAd: downloads.downloadAd,
                isCopySchemeUrl: isJumpQQlink,
                noKindFrom: 1,
            });
        }
    };

    const handleNodataBtnClick = (isSendCount = true, isJumpQQlink = false, isCallApp = true) => {
        const downloads = isVideoShare
            ? {}
            : {
                  download: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1526408161743',
                  downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=8984',
              };
        const client = isVideoShare ? 'videoApp' : 'newsApp';

        if (isCallApp) {
            callApp({
                client,
                docType: 'phvideo',
                pid,
                kind: 'inter_fxy20',
                download: downloads.download,
                downloadAd: downloads.downloadAd,
                isCopySchemeUrl: isJumpQQlink,
                noKindFrom: 1,
            });
        }
    };

    const schemeLinkMore = getSchemeLink({
        docType: 'phvideo',
        pid,
        kind: 'inter_fxy19',
        noKindFrom: 1,
    });

    const schemeLinkNoDataBtn = getSchemeLink({
        docType: 'phvideo',
        pid,
        kind: 'inter_fxy20',
        noKindFrom: 1,
    });

    return (
        <div className={styles.wrap}>
            <div className={styles.header}>
                <div className={styles.headerTitle}>评论详情</div>
                <div
                    className={styles.headerArrow}
                    onClick={() => {
                        closeDrag();
                    }}
                />
            </div>
            {initDone ? (
                <>
                    {comments.length ? (
                        <div className={styles.content}>
                            <div className={styles.list}>
                                {comments.map(comment => (
                                    <Comment content={{ ...comment, pid, isVideoShare }} key={comment.comment_id} />
                                ))}
                            </div>
                            {comments.length >= 30 ? (
                                <div className={styles.more} onClick={handleMoreClick}>
                                    {!isVideoShare && (
                                        <WxLaunchApp
                                            launchType={'app'}
                                            launchAppClick={() => {
                                                handleMoreClick(true, false, false);
                                            }}
                                            schemeLink={schemeLinkMore}
                                            launchAppFail={() => {
                                                handleMoreClick(false, true, true);
                                            }}
                                        />
                                    )}
                                    <div className={styles.moreText}>打开凤凰新闻，查看更多评论</div>
                                </div>
                            ) : (
                                <div className={styles.noMore}>
                                    <div className={styles.nomoreText}>没有更多啦</div>
                                </div>
                            )}
                        </div>
                    ) : (
                        <div className={styles.noData}>
                            <div className={styles.nodataIcon} />
                            <div className={styles.nodataText}>还没有精彩评论，快来APP内抢沙发</div>
                            <div className={styles.nodataBtn} onClick={handleNodataBtnClick}>
                                {!isVideoShare && (
                                    <WxLaunchApp
                                        launchType={'app'}
                                        launchAppClick={() => {
                                            handleNodataBtnClick(true, false, false);
                                        }}
                                        schemeLink={schemeLinkNoDataBtn}
                                        launchAppFail={() => {
                                            handleNodataBtnClick(false, true, true);
                                        }}
                                    />
                                )}
                                <div className={styles.nodataBtnText}>打开凤凰新闻客户端</div>
                            </div>
                        </div>
                    )}
                </>
            ) : null}
        </div>
    );
};

Comments.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(Comments);
